/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */
export const CssIncludes = "CssIncludes";
export const JavaScriptIncludes = "JavaScriptIncludes";
export const UHFHeaderHTML = "UHFHeader_en_US";
export const UHFFooterHTML = "UHFFooter_en_US";
export const FooterLangSelector = "locale-picker-link";
export const OpenInNewTab = "_blank";
export const OpenInSameTab = "_self";
export const UHFFooterLinksClassName = "c-uhff-link";
export const RequestQueryString = "MSGTAActionCenterQueryString";
export const ChevronRightMed = "ChevronRightMed";

export const FooterItems = {
  FAQ: "FAQ",
  Interview_tips: "Interview tips",
  Accessibility_request: "Accessibility request",
  Support: "Support",
  Legal_policies: "Legal policies",
  "Microsoft_Data_Privacy_Notice_(DPN)": "Microsoft Data Privacy Notice (DPN)",
  Labor_Condition_Application_Postings: "Labor Condition Application Postings",
  Follow_Microsoft_Careers: "Follow Microsoft Careers",
  Follow_us_on_social_media: "Follow us on social_media",
  Additional_support: "Additional support",
};

export const Footer = {
  FooterTop: "FooterTop",
  FooterBottom: "FooterBottom",
};

export enum ApplicationStatus {
  REQUESTED = "Requested",
  APPROVED = "Complete",
  DECLINED = "Reference Declined",
  ERROR = "Reference Error",
  PENDING = "Pending",
}

export enum ApplicationErrorStatus {
  NO_ERROR = "No reference error",
  EXPIRED = "Request expired",
  INVALID = "Invalid URL Given",
  DOWN = "Page Down",
}

export enum ErrorSeverity {
  Critical = 0,
  High = 1,
  Medium = 2,
  Low = 3,
}
export const uploadFileSizeLimitInMB = parseInt(
  process.env.REACT_APP_MAX_FILE_UPLOAD_SIZE || "10"
);

export const TelemetryLogs = {
  DelineRequest: "Reference - decline a request",
  PageViews: "Reference - Provider page views",
  PostOTPVerification: "Post OTP-Verification - Landing Page",
};

export const TelemetryErrorPageLogs = {
  ServerErrorPage: "References - Down Page",
  PageErrorPage: "Reference - Invalid URL",
};

export const TelemetrySubFeature = {
  HistorySection: "History section activity",
  LetterDownload: "Reference provider - Letter download",
};

export const ReferenceHistoryTexts = {
  headingText: "Your reference history for",
  successText: "Provided on",
  declinedText: "Declined on",
  noResultText: "No previous reference letter provided or declined",
  downloadText: "Reference letter",
};

export const TelemetryHistoryLogs = {
  DeclineReference: "DeclineReference",
  UploadReference: "UploadReference",
  ServerErrorReference: "ServerErrorReference",
  ReferenceHistoryError: "ReferenceHistoryError",
};

export const uploadFileFormats = ["pdf", "doc", "docx", "txt", "pptx"];
export const DefaultFileUploadName = "ReferenceLetter";
